(() => {
  const EVENT_NAME = 'nutrione_ux';
  const seenQuiz = new WeakSet();

  function emit(action, details = {}) {
    const payload = {
      event: EVENT_NAME,
      action,
      page_type: document.body?.classList.contains('template-product') ? 'product' : document.body?.dataset?.template || '',
      page_path: window.location.pathname,
      ...details,
    };

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
    window.dispatchEvent(new CustomEvent('nutrione:analytics', { detail: payload }));
  }

  window.NutrioneUX = Object.freeze({ track: emit });

  document.addEventListener('click', (event) => {
    const target = event.target.closest('a, button');
    if (!target) return;

    const quizOption = target.closest('[data-c-quiz] [data-answer]');
    if (quizOption) {
      const quiz = quizOption.closest('[data-c-quiz]');
      if (!seenQuiz.has(quiz)) {
        seenQuiz.add(quiz);
        emit('quiz_started');
      }
      emit('quiz_answered', {
        step: quizOption.getAttribute('data-answer') || '',
        answer: quizOption.getAttribute('data-value') || '',
      });
    }

    if (target.matches('[name="checkout"], a[href*="/checkout"]')) {
      emit('checkout_started');
      return;
    }

    if (target.matches('.sticky-buy-bar__btn')) {
      emit('cta_clicked', { cta: 'sticky_add_to_cart' });
    } else if (target.matches('[data-add-routine]')) {
      emit('cta_clicked', { cta: 'quiz_add_routine' });
    } else if (target.matches('[data-quiz-product-add]')) {
      emit('cta_clicked', { cta: 'quiz_add_product' });
    } else if (target.matches('[name="add"], .product-form__submit')) {
      emit('cta_clicked', { cta: 'add_to_cart' });
    } else if (target.matches('a.button, .button[href], .custom-buy-button')) {
      emit('cta_clicked', {
        cta: (target.textContent || '').trim().slice(0, 80),
        destination: target.getAttribute('href') || '',
      });
    }
  });

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (form.matches('form[action*="/search"]')) {
      emit('search_submitted', { query_length: new FormData(form).get('q')?.toString().length || 0 });
    }
  });

  function connectShopifyEvents() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return false;

    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event?.source !== 'product-form') return;
      emit('add_to_cart', {
        variant_id: String(event.productVariantId || ''),
        source: event.source,
      });
    });
    return true;
  }

  if (!connectShopifyEvents()) {
    window.addEventListener('load', connectShopifyEvents, { once: true });
  }

  document.querySelectorAll('[data-c-quiz]').forEach((quiz) => {
    const observer = new MutationObserver(() => {
      const result = quiz.querySelector('.c-quiz__result.is-active, [data-quiz-result].is-active');
      if (result && !result.dataset.analyticsComplete) {
        result.dataset.analyticsComplete = 'true';
        emit('quiz_completed');
      }
    });
    observer.observe(quiz, { subtree: true, attributes: true, attributeFilter: ['class'] });
  });
})();
